import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ClaimTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-claimtype',
  templateUrl: './claimtype.component.html',
  styleUrls: ['./claimtype.component.scss']
})
export class ClaimTypeComponent implements OnChanges {


  claimtypeForm: FormGroup;
  claimtypeFormArray: FormGroup;
  control = new FormControl();
  @Input() claimtypes: ClaimTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() claimtype = new EventEmitter<ClaimTypeDto[]>()
  @Output() deleteClaimTypeEvent = new EventEmitter<any>()

    selectedClaimType: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createClaimTypeForm();
    }

    createClaimTypeForm() {
      this.claimtypeForm = this.fb.group({
        ClaimTypeName: ['', Validators.required],
        id: null
        });
        this.claimtypeFormArray = this.fb.group({ ClaimTypes: this.fb.array([])
          });
        this.setClaimType();
    }

  // method to display claimtypes
  setClaimType() {
    const control  = this.claimtypeFormArray.controls.ClaimTypes as FormArray;
    this.claimtypes.forEach( e => {
      control.push(
        this.fb.group({
          ClaimTypeName: e.ClaimTypeName,
          id: e.id
        })
      );
    });
  }


  // method to add ClaimType
  addClaimType(value: ClaimTypeDto) {
    const control  = this.claimtypeFormArray.controls.ClaimTypes as FormArray;
    control.insert(0,
          this.fb.group({
            ClaimTypeName: value.ClaimTypeName,
            id: null
          })
       );
  }

  selectClaimType(value) {}

  // method to delete claimtype from arrary list
  deleteClaimType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.claimtypeFormArray.controls.ClaimTypes as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.claimtypes.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.claimtypes[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: ClaimTypeDto) {
    if(this.claimtypeForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.claimtypeFormArray.get('ClaimTypes')['controls'][this.selectedIndex].patchValue({ClaimTypeName: formValue.ClaimTypeName});
    } else {
      this.addClaimType(formValue);
    }
    this.selectedIndex = null;
    this.claimtypeForm.reset()
  }

  onEdit(index, value: ClaimTypeDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.claimtypeForm.patchValue({ClaimTypeName: value.ClaimTypeName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.claimtypeForm.reset();
  }

  onSubmit(formValue: ClaimTypeDto[]) {
  this.claimtype.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteClaimTypeEvent.emit(this.filteredDelete);
  }
  }

}
